import { Heading, Skeleton } from '@lanekassen/ui';
import { HtmlString } from '@modulis/utils';
import { TilleggsinfoBlokk } from '../epitekster/types';
import { useTeksterQuery } from '../hooks/queries';

interface TilleggsinfoBlokkWithLoaderProps {
  contentGuid: string;
}

function TilleggsinfoBlokkWithLoader({ contentGuid }: TilleggsinfoBlokkWithLoaderProps) {
  const { data: tilleggsinfo, isLoading } = useTeksterQuery<TilleggsinfoBlokk>(`TilleggsinfoBlock/${contentGuid}`);

  if (isLoading) {
    return <Skeleton variant="rectangular" height={40} />;
  }
  return (
    <>
      <Heading level={3} size="lg">
        {tilleggsinfo?.overskrift}
      </Heading>
      <HtmlString value={tilleggsinfo?.tekst} />
    </>
  );
}

export default TilleggsinfoBlokkWithLoader;
